import * as React from 'react';
import Status from './Status';
import { Status as StatusInterface } from '../types';

export interface ManyStatusProps {
  status: {
    state: string;
    message: string;
  }[];
  onExit: (arg0: StatusInterface) => void;
}

const ManyStatus: React.FC<ManyStatusProps> = ({ status, onExit }) => {
  return (
    <div className="absolute top-0 left-0 w-full">
      {status.map((el, idx) => (
        <Status
          key={`${el.message}-${idx}`}
          className="relative mb-2"
          state={el.state}
          message={el.message}
          onExit={() => onExit(el)}
        />
      ))}
    </div>
  );
};

export default ManyStatus;
